import { render, staticRenderFns } from "./AttachmentFields.vue?vue&type=template&id=3a48f431"
import script from "./AttachmentFields.vue?vue&type=script&lang=js"
export * from "./AttachmentFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports